import { useState } from 'react';
import {
  Box,
  Typography,
  Slider,
  Select,
  MenuItem,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const InvestmentCalculator = ({ stages = [] }) => {
  const [investment, setInvestment] = useState(100);
  const [selectedStage, setSelectedStage] = useState(0);

  const { precio, roi } = stages[selectedStage];

  const tokens = investment / precio;
  const totalReturn = investment * (roi / 100);
  const totalFutureValue = investment + totalReturn;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const formatUSD = (value) =>
    value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  if (stages.length === 0) return null;

  return (
    <Card sx={{ p: isMobile ? 1 : 2, maxWidth: 800 }}>
      <CardContent>
        <Typography variant={isMobile ? 'h6' : 'h5'} mb={3} color="white" gutterBottom>
          Calculadora de Rendimiento
        </Typography>

        {/* Selector de etapa */}
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel>Etapa</InputLabel>
          <Select
            value={selectedStage}
            label="Etapa"
            onChange={(e) => setSelectedStage(Number(e.target.value))}
            sx={{
              color: 'white',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#8c3e47',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#8c3e47',
              },
            }}
          >
            {stages.map((stage, index) => (
              <MenuItem key={index} value={index} sx={{ color: 'white' }}>
                Etapa {stage.etapa} - Precio: ${formatUSD(stage.precio)} USD - ROI {stage.roi.toFixed(2)}%
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Slider de inversión */}
        <Typography variant="subtitle1" color="white" gutterBottom>
          Monto a invertir: <strong>$ {formatUSD(investment)} USD</strong>
        </Typography>
        <Slider
          value={investment}
          min={10}
          max={10000}
          step={10}
          onChange={(e, val) => setInvestment(val)}
          valueLabelDisplay="auto"
        />

        {/* Mensaje de interés */}
        <Typography variant="h5" mt={2} pr={5} color="white">
          Si inviertes <strong>$ {formatUSD(investment)}</strong>, al finalizar la etapa ganarás aproximadamente <strong>$ {formatUSD(totalReturn)}</strong> de rendimiento.
        </Typography>

        {/* Detalles de inversión - estilo lista */}
        <Box mt={4}>
          <Typography variant="h5" color="white" gutterBottom>
            Detalles
          </Typography>
          <Box display="flex" flexDirection="column" gap={1} mt={2}>
            <Box display="flex" justifyContent="space-between" color="white">
              <Typography variant="body1">Tu inversión</Typography>
              <Typography variant="body1">$ {formatUSD(investment)} USD</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" color="white">
              <Typography variant="body1">Tokens a recibir</Typography>
              <Typography variant="body1">{tokens.toLocaleString('en-US', { maximumFractionDigits: 2 })} ALT-LND</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" color="white">
              <Typography variant="body1">Rendimiento estimado</Typography>
              <Typography variant="body1">$ {formatUSD(totalReturn)} USD</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" color="white">
              <Typography variant="body1">Valor futuro</Typography>
              <Typography variant="body1">$ {formatUSD(totalFutureValue)} USD</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" color="white">
              <Typography variant="body1">ROI</Typography>
              <Typography variant="body1">{roi.toFixed(2)}%</Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default InvestmentCalculator;

